import "./Contacts.module.css";
import Header from "@/reusable_sections/Header";
import ParliamoDelTuoProgetto from "./sections/ParliamoDelTuoProgetto";
import FaqTecniche from "./sections/FaqTecniche";
import PièDiPagina from "@/reusable_sections/Footer";
export default function ContactsPage() {
  return <div>
      <Header />
      <ParliamoDelTuoProgetto />
      <FaqTecniche />
      <PièDiPagina />
    </div>;
}